/**
 * TypeScript wrapper around the shared pricing adjustment merge logic in
 * quote_app/common/pricingAdjustmentMerge.mjs. The implementation lives in
 * common/ so backend integration tests can exercise it; this file just adds
 * type definitions for client consumers.
 */
// @ts-ignore - .mjs file with JSDoc types
import {
   extractFamilyKeys as _extractFamilyKeys,
   mergePricingAdjustments as _mergePricingAdjustments,
} from '../common/pricingAdjustmentMerge.mjs'

export interface PricingAdjustmentData {
   numberDiscountValues: Record<string, number>
   discountStates: Record<string, boolean | string>
}

export type PromotionalDiscountsLike = Record<string, unknown> & {
   numberDiscountValues?: Record<string, number>
}

export interface DiscountListEntry {
   DiscountCode?: string | null
   DiscountFamily?: string | null
}

export interface MergeInputs {
   prevState: PromotionalDiscountsLike
   pricingData: PricingAdjustmentData
   userOwnedFamilies: Set<string>
   prevPricingAdjKeys: string[]
   discountList: Record<string, DiscountListEntry>
}

export interface MergeResult {
   newState: PromotionalDiscountsLike
   newPricingAdjKeys: string[]
}

export const extractFamilyKeys = _extractFamilyKeys as (
   discounts: Record<string, unknown> | null | undefined,
) => Set<string>

export const mergePricingAdjustments = _mergePricingAdjustments as (
   inputs: MergeInputs,
) => MergeResult
